import React from 'react';
import Navbar from '../components/Navbar';

const CV = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Navbar */}
      <div className="md:hidden">
        <Navbar dark={false} mobile={true} />
      </div>
      
      {/* Desktop Navbar */}
      <div className="hidden md:block">
        <Navbar dark={false} />
      </div>
      
      <div className="container mx-auto px-2 md:px-4 py-2 md:py-8">
        <div className="max-w-4xl mx-auto">
          {/* Mobile Download Option */}
          <div className="md:hidden mb-4 text-center">
            <p className="text-sm text-gray-600 mt-2">For best viewing experience</p>
            <a 
              href="/cv.pdf" 
              className="inline-block bg-gray-800 text-white px-6 py-3 rounded-full font-medium hover:bg-gray-700 transition-colors mt-4"
              download
            >
              Fullscreen
            </a>
          </div>
          
          {/* PDF Viewer */}
          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="relative w-full overflow-auto">
              <iframe
                src="/cv.pdf#view=FitH"
                title="CV Document"
                className="w-full h-[500px] md:h-screen"
                style={{ 
                  minHeight: '500px', 
                  maxHeight: '80vh',
                  border: 'none'
                }}
                scrolling="yes"
              >
                <p>Your browser does not support PDFs. 
                  <a href="/cv.pdf" className="text-blue-600 hover:underline">Download the PDF</a> instead.
                </p>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CV;